import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export function RToggleSwitch({ checked, onChange }: RToggleSwitchProps) {
    return <Switch type="checkbox" checked={checked} onChange={() => onChange(!checked)} />;
}

const Switch = styled('input')({
    appearance: 'none',
    width: 40,
    height: 22,
    borderRadius: 11,
    backgroundColor: Colors.lightGrey,
    position: 'relative',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:checked': { backgroundColor: Colors.turquoise },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 2,
        left: 2,
        width: 18,
        height: 18,
        borderRadius: '50%',
        backgroundColor: Colors.white,
        transition: 'transform 0.2s',
    },
    '&:checked::after': { transform: 'translateX(18px)' },
});
